import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { from, switchMap } from 'rxjs';
import { AnimationKey, getAnimationDefinition, resolveAnimationSize } from './animation-registry';

/**
 * Renders a code-managed animation by Storyblok key.
 * Reusable inside teaser creatives, standalone animation blocks, and elsewhere.
 */
@Component({
  selector: 'app-animation-host',
  templateUrl: './animation-host.component.html',
  styleUrl: './animation-host.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgComponentOutlet],
})
export class AnimationHostComponent {
  readonly animation = input<AnimationKey>(undefined);
  readonly width = input<number | string>(undefined);
  readonly height = input<number | string>(undefined);

  readonly definition = toSignal(
    toObservable(this.animation).pipe(switchMap(key => from(getAnimationDefinition(key))))
  );

  readonly size = computed(() => resolveAnimationSize(this.definition(), this.width(), this.height()));

  readonly componentInputs = computed(() => ({
    width: this.size().width,
    height: this.size().height,
  }));
}
